import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteCase } from 'src/store/actions/case-actions';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { ICase } from 'src/types/case';

interface Props {
    data: ICase;
}

const DeleteCaseAction: React.FunctionComponent<Props> = ({ data: { id } }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };
    return (
        <>
            <button type="button" className="btn btn-secondary" onClick={() => setOpened(true)}>
                <FontAwesomeIcon icon={faTrash} />
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete Case # {`${id}`} from the system?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() =>
                            dispatch(
                                deleteCase(id, handleClose, (errorMessage: string) => {
                                    handleClose();
                                    toast.error(errorMessage);
                                }),
                            )
                        }
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeleteCaseAction;
